<!--
 * @Author: your name
 * @Date: 2021-09-27 17:48:35
 * @LastEditTime: 2022-11-30 14:53:17
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\strategy\logistics\orderMoney\components\DataForm.vue
-->
<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <el-col :span="span">
      <el-form-item :label="$t('settingWarehouse.addAndEdit.code')" prop="storehouseNo">
        <BjInput
          v-model="form.storehouseNo"
          :placeholder="$t('settingWarehouse.addAndEdit.warehouseText')"
          :maxlength="MAX_LENGTH.DEFAULT"
          disabled
        >
          <template #append>
            <el-button type="primary" @click="openWarehouseDialog()">{{ $t('settingWarehouse.addAndEdit.selectWarehouse') }}</el-button>
          </template>
        </BjInput>
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingWarehouse.addAndEdit.name')" prop="storehouseName">
        <BjInput
          v-model="form.storehouseName"
          :placeholder="$t('settingWarehouse.addAndEdit.warehouseText')"
          :maxlength="MAX_LENGTH.DEFAULT"
          disabled
        />
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingWarehouse.addAndEdit.logistics')" prop="logisticCompanyId">
        <BjSelectLogisticCompany
          :value="form.logisticCompanyId"
          :default-options="{
            label: form.logisticCompanyName,
            value: form.logisticCompanyId,
          }"
          @change="onLogistic"
        />
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingWarehouse.addAndEdit.business')" prop="logisticBusinessId">
        <BjSelectLogisticBusiness
          :value="form.logisticBusinessId"
          :disabled="!form.logisticCompanyId"
          :default-params="defaultParams"
          :default-options="{
            label: form.logisticBusinessName,
            value: form.logisticBusinessId,
          }"
          :placeholder="form.logisticCompanyId ? $t('chooseText') : $t('settingWarehouse.addAndEdit.logisticsText')"
          @change="onBusiness"
        />
      </el-form-item>
      <el-form-item :label="$t('settingWarehouse.addAndEdit.priority')" prop="orderNum">
        <el-input-number
          v-model="form.orderNum"
          :maxlength="MAX_LENGTH.DEFAULT"
          :min="0"
          :max="MAX_LENGTH.PRIORITY"
          :precision="0"
          :controls="false"
        />
        <span class="text-muted font12 ml0">{{ $t('settingWarehouse.addAndEdit.priorityText') }}</span>
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingWarehouse.addAndEdit.express')" prop="deliveryCheck">
        <el-switch v-model="form.deliveryCheck" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingWarehouse.addAndEdit.returnExpress')" prop="returnGoodsCheck">
        <el-switch
          v-model="form.returnGoodsCheck"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>
    </el-col>
    <BjDialogList
      ref="warehouse"
      row-keys="code"
      :config="$BjDialogListConfig.stockWarehouseLogic()"
      :disabled="dialogDisabled"
      @confirm="onConfirmWarehouseList"
    />
  </BjDrawerForm>
</template>
<script>
import { settingApi } from '@/api';
const getDefaultForm = () => {
  return {
    storehouseNo: null,
    storehouseName: null,
    logisticCompanyId: null,
    logisticCompanyNo: null,
    logisticCompanyName: null,
    logisticBusinessId: null,
    logisticBusinessNo: null,
    logisticBusinessName: null,
    orderNum: null,
    enabledFlag: true,
    deliveryCheck: 1,
    returnGoodsCheck: 1,
  };
};

export default {
  props: {
    warehouse: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      span: 20,
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        storehouseNo: [{ required: true, message: this.$t('settingWarehouse.addAndEdit.selectWarehouse'), trigger: 'change' }],
        storehouseName: [{ required: true, message: this.$t('settingWarehouse.addAndEdit.selectWarehouse'), trigger: 'change' }],
        logisticCompanyId: [{ required: true, message: this.$t('settingWarehouse.addAndEdit.selectLogistics'), trigger: 'change' }],
        logisticBusinessId: [{ required: true, message: this.$t('settingWarehouse.addAndEdit.selectBusiness'), trigger: 'change' }],
        orderNum: [{ required: true, message: this.$t('settingWarehouse.addAndEdit.selectPriority'), trigger: 'blur' }],
      },
      dialogDisabled: [],
    };
  },
  computed: {
    defaultParams() {
      // 以 所属物流商 为默认参数
      return { companyId: this.form.logisticCompanyId, enableFlag: true };
    },
  },
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.$nextTick(() => {
        this.isEdit = !!info;
        this.$refs.BjDrawerForm.show();
        this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('settingWarehouse.addAndEdit.editWarehouse') : this.$t('settingWarehouse.addAndEdit.addWarehouse'));
        this.form = Object.assign(getDefaultForm(), info || {});
      });
    },
    openWarehouseDialog() {
      let selectedRows = [];
      if (this.form.code || this.form.storehouseNo) {
        selectedRows = [
          {
            ...this.form,
            code: this.form.code || this.form.storehouseNo,
          },
        ];
      }
      this.$refs.warehouse.show(selectedRows);
    },
    onConfirmWarehouseList(data) {
      const { code, name } = data[0];
      this.form.storehouseNo = code;
      this.form.storehouseName = name;
    },
    onLogistic(val, data = {}) {
      this.form.logisticCompanyId = data.id;
      this.form.logisticCompanyNo = data.code;
      this.form.logisticCompanyName = data.name;

      this.form.logisticBusinessId = null;
      this.form.logisticBusinessNo = null;
      this.form.logisticBusinessName = null;
    },
    onBusiness(val, data = {}) {
      this.form.logisticBusinessId = data.id;
      this.form.logisticBusinessNo = data.code;
      this.form.logisticBusinessName = data.name;
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }
      this.saveApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },

    saveApi(API_DATA) {
      if (this.isEdit) {
        settingApi.updateStrategyStoreHouses(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      } else {
        settingApi.addStrategyStoreHouses(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
